import * as Types from '../../types';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type GetBlocksQueryVariables = Types.Exact<{
  after?: Types.InputMaybe<Types.Scalars['String']['input']>;
  before?: Types.InputMaybe<Types.Scalars['String']['input']>;
  first?: Types.InputMaybe<Types.Scalars['Int']['input']>;
  last?: Types.InputMaybe<Types.Scalars['Int']['input']>;
  sort?: Types.InputMaybe<Types.SortInput>;
  filters?: Types.InputMaybe<Array<Types.FilterInput> | Types.FilterInput>;
}>;

export type GetBlocksQuery = {
  __typename?: 'Query';
  blocks: {
    __typename?: 'BlockConnection';
    totalCount: number;
    pageInfo: {
      __typename?: 'PageInfo';
      hasNextPage: boolean;
      hasPreviousPage: boolean;
      startCursor?: string | null;
      endCursor?: string | null;
    };
    edges: Array<{
      __typename?: 'BlockEdge';
      cursor: string;
      node: {
        __typename?: 'Block';
        number: number;
        hash: string;
        transactionCount?: number | null;
        timestamp: any;
        valueNative?: any | null;
        valueUsd?: any | null;
      };
    }>;
  };
};

export const GetBlocksDocument = gql`
  query GetBlocks(
    $after: String
    $before: String
    $first: Int
    $last: Int
    $sort: SortInput
    $filters: [FilterInput!]
  ) {
    blocks(
      after: $after
      before: $before
      first: $first
      last: $last
      sort: $sort
      filters: $filters
    ) {
      totalCount
      pageInfo {
        hasNextPage
        hasPreviousPage
        startCursor
        endCursor
      }
      edges {
        cursor
        node {
          number
          hash
          transactionCount
          timestamp
          valueNative
          valueUsd
        }
      }
    }
  }
`;

/**
 * __useGetBlocksQuery__
 *
 * To run a query within a React component, call `useGetBlocksQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetBlocksQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetBlocksQuery({
 *   variables: {
 *      after: // value for 'after'
 *      before: // value for 'before'
 *      first: // value for 'first'
 *      last: // value for 'last'
 *      sort: // value for 'sort'
 *      filters: // value for 'filters'
 *   },
 * });
 */
export function useGetBlocksQuery(
  baseOptions?: Apollo.QueryHookOptions<
    GetBlocksQuery,
    GetBlocksQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetBlocksQuery, GetBlocksQueryVariables>(
    GetBlocksDocument,
    options,
  );
}
export function useGetBlocksLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetBlocksQuery,
    GetBlocksQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetBlocksQuery, GetBlocksQueryVariables>(
    GetBlocksDocument,
    options,
  );
}
export function useGetBlocksSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<GetBlocksQuery, GetBlocksQueryVariables>,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<GetBlocksQuery, GetBlocksQueryVariables>(
    GetBlocksDocument,
    options,
  );
}
export type GetBlocksQueryHookResult = ReturnType<typeof useGetBlocksQuery>;
export type GetBlocksLazyQueryHookResult = ReturnType<
  typeof useGetBlocksLazyQuery
>;
export type GetBlocksSuspenseQueryHookResult = ReturnType<
  typeof useGetBlocksSuspenseQuery
>;
export type GetBlocksQueryResult = Apollo.QueryResult<
  GetBlocksQuery,
  GetBlocksQueryVariables
>;
